module.exports = __webpack_public_path__ + "static/pallav-nadhani-632669658166a64da9cde57a07c4d03a.png";